export default __webpack_public_path__ + "9364857d8cb46beacc7dc81cc00da1e3.svg";